import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '../services/common.service';

@Pipe({
    name: 'languageKeyToDisplayLanguage',
    standalone: false
})

// transforms en-US to English, de-DE to German
export class LanguageKeyToDisplayLanguagePipe implements PipeTransform {
    transform(languageKey: string, shouldReturnLang = false): string {
        if (shouldReturnLang) {
            return CommonService.getLangFromLanguageKey(languageKey);
        }
        return CommonService.getDisplayLanguageFromLanguageKey(languageKey);
    }
}
